<template>
    <div class="mp-media-activity">
        <el-row class="section" v-show="item.sameGgh">
            <el-col :span="24">
                <el-collapse accordion v-model="activeName">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <span>请选择公众号：</span>
                        </template>
                        <div class="grid-content bg-purple-dark">
                            <el-row>
                                <el-col :span="12">
                                    <el-select v-model="mpAuthConfigId" placeholder="请选择公众号">
                                        <el-option
                                                v-for="item in mpAuthConfigs"
                                                :key="item.id"
                                                :label="item.nickName"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </div>

                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>


        <el-row class="setting section">
            <el-col :span="24">
                <el-collapse accordion v-model="activeName1">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <div class="title">
                                <div @click.stop>
                                    <span>是否开启：</span>
                                    <el-switch v-model="item.open"></el-switch>
                                </div>
                                <span v-if="item.triggerType"
                                      class="trigger">触发方式：<strong>{{item.triggerTypeText}}</strong></span>
                                <span v-if="item.triggerType=='keyword'"
                                      class="trigger">关键词：<strong>{{item.keyword}}</strong></span>
                                <a class="head-tip" href="https://www.yuque.com/yifakeji/irpssl/hoe2tm"
                                   target="_blank">不会设置?点击看活码设置教程</a>
                            </div>
                        </template>
                        <el-alert
                                title="温馨提示"
                                type="success"
                                close-text="知道了"
                                show-icon>
                            <p>选择同步公众号以后，活码将自动和公众号同步</p>
                            <p>请先保存，保存以后，才可以设置下面的文案和活码</p>
                        </el-alert>
                        <div class="grid-content bg-purple-dark">
                            <el-form ref="form" :model="item" label-width="100px" label-position="left">
                                <el-form-item label="同步公众号:">
                                    <el-switch v-model="item.sameGgh"></el-switch>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" size="medium" @click="onSubmit">保存</el-button>
                                    <el-button size="medium">取消</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>
        <el-row class="section">
            <el-col :span="24">
                <el-tabs type="border-card" v-model="currentTab">
                    <el-tab-pane label="文案" name="first">
                        <text_list :sort=1 :mediaActivityId="item.id"
                                   v-if="currentTab=='first'&&item.id"></text_list>
                    </el-tab-pane>
                    <el-tab-pane label="活码图片" name="second" v-if="!item.sameGgh">
                        <image_list :mediaActivityId="item.id"
                                    v-if="currentTab=='second'&&item.id"></image_list>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
    </div>

</template>
<script>
    import {mediaActivityApi} from "../../common/mediaActivityApi"
    import {mpAuthConfigApi} from "../../common/mpAuthConfigApi";

    export default {
        name: "index",
        components: {
            text_list: require('./text_list').default,
            image_list: require('./image_list').default,
        },
        watch: {
            'item.triggerType': {
                handler: function () {
                    if (this.item.triggerType == 'keyword') {
                        this.item.triggerTypeText = "关键词触发"
                    } else if (this.item.triggerType == 'subscribe') {
                        this.item.triggerTypeText = "关注触发"
                    } else {
                        this.item.triggerTypeText = "关键词、关注都触发"
                    }
                }
            },
            'item.sameGgh': {
                handler: function () {
                    if (this.item.sameGgh) {
                        this.loadMpAuthConfigs();
                    }
                }
            },
            mpAuthConfigId(newValue, oldValue) {
                this.refresh = false;
                this.refresh = true;

            }


        },
        created() {

        },
        mounted() {
            this.onload()
        },
        data() {
            return {
                isSaving:false,
                open: false,
                showMpChoose: false,
                currentTab: 'first',
                activeName: "1",
                activeName1: "1",
                mpAuthConfigId: null,
                sameGgh: false,
                mpAuthConfigs: [],
                item: {
                    open: false,
                    triggerType: 'keyword',
                    triggerTypeText: "关键词触发",
                    id: null,
                },
                tabs: [],
                texts: [],
                refresh: false
            }
        },
        methods: {
            loadMpAuthConfigs() {
                var that = this
                mpAuthConfigApi.getMpAuthConfigs.call(that, {}, function (res) {
                    var pastMpConfigs = []
                    if (res.result.mpConfigs && res.result.mpConfigs.length > 0) {
                        for (var i = 0; i < res.result.mpConfigs.length; i++) {
                            if (res.result.mpConfigs[i].mpAuthConfigStatus == 'HAS_PAST') {
                                pastMpConfigs.push(res.result.mpConfigs[i])
                            }
                        }

                    } else {
                        that.$message.error("还没有授权公众号，请先授权公众号，并设置公众号活码!")
                        that.item.sameGgh=false;
                    }
                    if (pastMpConfigs.length > 1) {
                        that.showMpChoose = true
                    }
                    that.mpAuthConfigs = pastMpConfigs;
                    if (that.item && that.item.mpAuthConfigId()) {
                        that.mpAuthConfigId = that.item.mpAuthConfigId;
                    } else {
                        that.mpAuthConfigId = pastMpConfigs[0].id;
                    }
                })
            },
            onload() {
                var that = this;
                mediaActivityApi.getMediaActivity.call(that, {mediaActivityType: 'xcx', scene: 'xcx'}, function (res) {
                        if (res.result.data && res.result.data.length > 0) {
                            that.item = null;
                            that.item = res.result.data[0];
                            that.mpAuthConfigId = that.item.mpAuthConfigId;
                            that.$forceUpdate();

                        } else {
                            that.item = {};
                        }
                    },
                    function (data) {

                    }
                )
            },
            newText() {
                this.texts.push({"text": ""})
            },
            deleteText(index) {
                this.texts.splice(index, 1)
            },
            onSubmit() {
                var that = this;
                that.item.mpAuthConfigId = that.mpAuthConfigId
                that.item.mediaActivityType = 'xcx'
                that.item.scene = 'xcx'
                mediaActivityApi.createMediaActivity.call(that, that.item, function (res) {
                    if (res.result.item) {
                        that.item = res.result.item;
                    }
                })
            }
        }
    }

</script>
<style lang="scss">

    .mp-media-activity {
        text-align: left;

        .head-tip {
            margin-left: 10px;
            color: #ff0036;
        }

        .title {
            margin-left: 10px;
            display: flex;
            align-items: center;

            .trigger {
                margin-left: 20px;
            }

            strong {
                color: $hover-color;
            }

        }

        .el-collapse {
            border: none;
        }

        .el-collapse-item__wrap {
            border: none;
        }


        .el-collapse-item__content {
            padding-bottom: 0px;
        }
    }

</style>